import React from "react";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { debounce } from "lodash";
import { storage } from "../../utils/storage";
import NavBar from "../../nav/nav-bar";
import Header from "../../header/header";
import ReportNav from "../report-nav";
import Footer from "../../footer/footer";
import DatePicker from "react-multi-date-picker";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import moment from "moment";
import Service from "../../webservice/http";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import config from "../../config";
import Pagination from "../../components/pagination";
import ReportFilter from "../report-filter";
import { FaFilter } from "react-icons/fa";
import ReportFilterBanner from "../report-filter-banner";

function CollectionStrategy() {
  const tableHeadingArray = [
    " Call Date ",
    "Call Reference",
    "Customer",
    "Product",
    "Agent",
    "Call Language",
    "Review",
    "Action",
  ];

  const defaultDate = [
    moment().subtract(1, "months").format("DD-MM-YYYY"),
    moment().format("DD-MM-YYYY"),
  ];

  const services = new Service();
  const history = useHistory();
  const role = storage.getItem("role");
  const isAgentRole =
    role === "Agent" ||
    role === "Agenth" ||
    role === "Agent Collections" ||
    role.includes("Agent");

  const [tabledata, setTabledata] = useState([]);
  const [search, setSearch] = useState("");
  const [value, setValue] = useState([
    new Date().setMonth(new Date().getMonth() - 1),
    new Date(),
  ]);
  const [range, setRange] = useState("");
  const [Loading, setLoading] = useState(false);

  // Global report filter state
  const [reportFilterWidth, setReportFilterWidth] = useState(0);
  const [isReportFilterOpen, setIsReportFilterOpen] = useState(false);
  const [reportFilters, setReportFilters] = useState({});

  const changeReportFilterWidth = () => {
    if (reportFilterWidth === 550) {
      setReportFilterWidth(0);
      setIsReportFilterOpen(false);
    } else {
      setReportFilterWidth(550);
      setIsReportFilterOpen(true);
    }
  };

  const handleReportFilterApply = (appliedFilters) => {
    setReportFilters(appliedFilters);
  };

  const handleReportFilterReset = () => {
    setReportFilters({});
  };

  const buildQueryParams = (filters) => {
    const params = new URLSearchParams();
    const mapping = {
      lob: "lob_name",
      manager: "manager_name",
      team_lead: "team_lead_name",
      agent: "agent_name",
      dca_organization: "dca_organization_name",
      dca_manager: "dca_manager_name",
      dca_team: "dca_team_lead_name",
      dca_agent: "dca_agent_name",
      collection_strategy: "collection_strategy",
      product_type: "product_name",
      time_period: "period",
      from_date: "from_date",
      to_date: "to_date",
      bucket_type: "bucket_type",
    };
    for (const [key, value] of Object.entries(filters)) {
      if (mapping[key] && value) params.append(mapping[key], value);
      else if (value && !mapping[key]) params.append(key, value);
    }
    return params.toString().replace(/\+/g, "%20");
  };

  const [totalpage, setTotalpage] = useState([]);
  const [totalresult, setTotalresult] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [maxpage, settMaxpage] = useState("");

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    history.push(`/reports/collection-strategy/?page=${pageNumber}`);
  };

  async function Dashbaorddata(filters = {}) {
    setLoading(true);

    let baseUrl = `api/call_verification/collection_strategy_list/`;
    const params = new URLSearchParams();

    if (range.length === 2) {
      params.append("from_date", range[0]);
      params.append("to_date", range[1]);
    }
    if (search) {
      params.append("search", search);
    }
    const filterQs = buildQueryParams(filters);
    if (filterQs) {
      filterQs.split("&").forEach((pair) => {
        const [k, v] = pair.split("=");
        if (k && v) params.append(decodeURIComponent(k), decodeURIComponent(v));
      });
    }

    const queryParams = new URLSearchParams(window.location.search);
    const page = queryParams.get("page") || "1";
    params.append("page", page);

    const url = `${baseUrl}?${params.toString().replace(/\+/g, "%20")}`;

    try {
      const res = await services.get(url);
      setTabledata(res?.data);
      setTotalpage(res?.pagination?.page_numbers);
      setTotalresult(res?.pagination?.total_results);
      settMaxpage(res?.pagination?.total_pages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }

  useEffect(() => {
    Dashbaorddata(reportFilters);
  }, [history, currentPage, range, search, reportFilters]);

  const debouncedSearch = debounce((value) => {
    setSearch(value.toLowerCase());
  }, 500);

  const handleDates = (dates) => {
    if (dates) {
      const range = dates.map((date) => {
        return date.format("DD/MM/YYYY");
      });
      setRange(range);
    }
  };

  return (
    <div>
      <Header />
      <NavBar />

      <div>
        <div className="container-fluid" style={{ background: "#EEF2F5" }}>
          <div className="my-call bg-white">
            <div
              className="side-panel-with-table clearfix flex"
              style={{ display: "flex" }}
            >
              <ReportNav />
              <div className="call-table" style={{ marginBottom: "80px" }}>
                {/* Active filter banner — non-agent roles */}
                {!isAgentRole && (
                  <ReportFilterBanner
                    filters={reportFilters}
                    onClear={handleReportFilterReset}
                  />
                )}
                <div
                  className="my-calls-column"
                  style={{ padding: "15px 0px 0px 15px" }}
                >
                  <div className="calls-top-pannel">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="pannel-heading clearfix">
                          <div className="pannel-heading-icon">
                            <i
                              className="fa fa-snowflake-o"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="pannel-heading-info">
                            <h3>Collection Strategy</h3>
                            <p> Details</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" flex justify-end   items-center m-10">
                  {/* <div className="mr-6 inline-block rounded-lg border"> */}
                  <input
                    onChange={(event) => debouncedSearch(event.target.value)}
                    type="text"
                    placeholder="Search by customer name"
                    className="search-tag"
                    style={{
                      // border: "1px solid transparent",
                      border: "none",
                      background: "#eef2f5",
                      borderRadius: "10px",
                      width: "250px",
                      outline: "none",
                      paddingLeft: "8px",
                      height: "35px",
                    }}
                  />
                  {/* </div> */}
                </div>
                <div className=" overflow-x-scroll">
                  <table className="ss" style={{ border: "1px solid grey" }}>
                    <tr id="black-line">
                      {tableHeadingArray
                        .filter((item) => {
                          const userRole = storage.getItem("role");
                          if (
                            (userRole === "Agent" || userRole === "Agenth") &&
                            item === "Action"
                          ) {
                            return false;
                          }
                          return true;
                        })
                        .map((item, indx) => (
                          <th
                            key={item}
                            className={`
                               left-0 bg-white  border-b-2 border-gray-200 px-5 py-4 text-left  text-xl font-semibold  tracking-wider text-black  
                                
                               }  `}
                          >
                            {item}
                          </th>
                        ))}
                    </tr>

                    <tbody>
                      {Loading && (
                        <tr>
                          <td colSpan="11" style={{ textAlign: "center" }}>
                            <ClipLoader color="#2056FF" size="50px" />
                          </td>
                        </tr>
                      )}

                      {tabledata.length ? (
                        tabledata.map((e, i) => {
                          return (
                            <tr
                              key={i}
                              // className={`${
                              //   e["Call Status"] === "Fatal"
                              //     ? " bg-red-500"
                              //     : " bg-green-500"
                              // }`}
                              className=" cursor-pointer"
                              // style={{ background: "red" }}
                              onClick={() =>
                                history.push(
                                  `/reports/detail/${e.id}/collection-strategy`,
                                )
                              }
                            >
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs first-letter `}
                              >
                                <div>
                                  <p className="whitespace-no-wrap cursor-pointer text-left text-sky-700">
                                    {e.call_date}
                                  </p>
                                </div>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs first-letter `}
                              >
                                <div>
                                  <p className="whitespace-no-wrap cursor-pointer text-left text-sky-700">
                                    {e.call_reference}
                                  </p>
                                </div>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2    text-xs`}
                                id="date"
                              >
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {e?.customer_name}
                                </p>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs`}
                              >
                                <p className="whitespace-no-wrap text-left text-gray-900">
                                  {e?.product}
                                </p>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs sticky left-0 `}
                              >
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {e?.agent}
                                </p>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs sticky left-0 `}
                              >
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {e?.language}
                                </p>
                              </td>

                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs sticky left-0 `}
                              >
                                <div className="flex justify-start items-center ml-4">
                                  {e?.call_reviewed ? (
                                    <p
                                      className="font-bold"
                                      style={{
                                        color: "green",
                                        fontSize: "16px",
                                      }}
                                    >
                                      <i
                                        className="fa fa-check-circle"
                                        aria-hidden="true"
                                      ></i>
                                    </p>
                                  ) : (
                                    <p
                                      className="font-bold"
                                      style={{ color: "red", fontSize: "16px" }}
                                    >
                                      <i
                                        className="fa fa-times-circle"
                                        aria-hidden="true"
                                      ></i>
                                    </p>
                                  )}
                                </div>
                              </td>
                              {storage.getItem("role") !== "Agent" &&
                                storage.getItem("role") !== "Agenth" && (
                                  <td
                                    className={`border-b border-gray-200 px-5 py-2  w-40 text-xs cursor-pointer whitespace-nowrap`}
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    <button
                                      className="edit hover:text-white hover:ease-in-out hover:duration-600 text-white"
                                      style={{
                                        border: "1px solid lightgray",
                                        padding: "10px 15px",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        history.push({
                                          pathname: `/reports/detail/${e.id}/collection-strategy`,
                                          state: { isEdit: true },
                                        });
                                      }}
                                    >
                                      Edit
                                    </button>
                                  </td>
                                )}
                            </tr>
                          );
                        })
                      ) : Loading ? (
                        ""
                      ) : (
                        <tr>
                          <td colSpan="11" style={{ textAlign: "center" }}>
                            No Record Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalpage?.length}
                    onPageChange={handlePageClick}
                    totalresult={totalresult}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Global Report Filter — non-agent roles only */}
      {!isAgentRole && (
        <>
          <button
            onClick={changeReportFilterWidth}
            title="Global Filters"
            style={{
              position: "fixed",
              transition: "0.5s",
              top: "30%",
              right: reportFilterWidth > 0 ? reportFilterWidth + 8 : 25,
              backgroundColor:
                Object.keys(reportFilters).length > 0 ? "#271078" : "#F99E52",
              color: "white",
              padding: "10px",
              height: "40px",
              width: "40px",
              zIndex: 2001,
              borderRadius: "10%",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            }}
          >
            <FaFilter size={18} />
            {Object.keys(reportFilters).length > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "-4px",
                  right: "-4px",
                  backgroundColor: "#F99E52",
                  color: "#fff",
                  borderRadius: "50%",
                  width: "18px",
                  height: "18px",
                  fontSize: "10px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {Object.keys(reportFilters).length}
              </span>
            )}
          </button>

          <ReportFilter
            width={reportFilterWidth}
            changeSideBarWidth={changeReportFilterWidth}
            onApplyFilter={handleReportFilterApply}
            onResetFilter={handleReportFilterReset}
            userRole={role}
          />

          {isReportFilterOpen && (
            <div
              className="backdrop"
              onClick={changeReportFilterWidth}
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.35)",
                zIndex: 1999,
              }}
            />
          )}
        </>
      )}

      <Footer />
    </div>
  );
}

export default CollectionStrategy;
